import { Theme } from "@mui/material";

/** Shared "card" look for every DataGrid table in the back office. */
export const dataGridSurface = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 14,
  boxShadow: "0 1px 3px rgba(16,24,40,0.05), 0 1px 2px rgba(16,24,40,0.03)",
  overflow: "hidden",
  "& .MuiDataGrid-root": {
    border: "none",
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F8FAFC",
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: 12.5,
  },
  "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 600 },
  "& .MuiDataGrid-columnSeparator": { display: "none" },
  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
    fontSize: 14,
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    { outline: "none" },
  "& .MuiDataGrid-row:hover": { backgroundColor: "#F5F7FF" },
  "& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover": {
    backgroundColor: theme.palette.primary.light,
  },
  "& .MuiDataGrid-virtualScroller": { backgroundColor: theme.palette.background.paper },
  "& .MuiDataGrid-footerContainer": {
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiTablePagination-root": { color: theme.palette.text.secondary },
  "& .MuiCheckbox-root": { color: theme.palette.grey[400] },
  "& .MuiCheckbox-root.Mui-checked": { color: theme.palette.primary.main },
  "& .name-column--cell": { color: theme.palette.text.primary, fontWeight: 600 },
});
